// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./permission";
import "lib-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import "@vant/touch-emulator";
import "@/assets/icon/iconfont.css";
import { Toast } from "vant";
import store from "./store";
import VueI18n from "vue-i18n";
import ZH from "./language/zh";
import EN from "./language/en";
import "./styles/index.less";

import { packageStatusConver } from "./js/index";
import VueClipboard from "vue-clipboard2";

Vue.use(Vant);
Toast.setDefaultOptions({ duration: 2000 });
Vue.use(VueClipboard);

Vue.use(VueI18n);

const i18n = new VueI18n({
  //从localStorage里获取用户中英文选择，没有则默认中文
  locale: localStorage.getItem("languageSet") || "zh",
  messages: {
    zh: ZH,
    en: EN,
  },
  fallbackLocale: "zh",
  silentFallbackWarn: true,
});

Vue.config.productionTip = false;
Vue.prototype.packageStatusConver = packageStatusConver;

new Vue({
  el: "#app",
  i18n,
  router,
  store,
  render: h => h(App),
});
